/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { FormProvider } from "@simplicitycms/simplicity-forms";
import { Form } from "@simplicitycms/simplicity-forms";
// import { FormProvider } from "cms/forms/context";
// import { Form } from "cms/forms/form";

const FormsComponent = (props) => {
    const component = props?.component;
    const domain = window.location.host;

    return (
        <FormProvider domain={domain}>
            <Form component={component} />
        </FormProvider>
    );
};

FormsComponent.displayName = "FormsComponent";

export { FormsComponent };
